function initializeSlideshow() {
  if (typeof Swiper === 'undefined') {
    console.log('Swiper not loaded yet, retrying...');
    setTimeout(initializeSlideshow, 100);
    return;
  }

  const swiperContainer = document.querySelector('.article-slideshow');
  if (!swiperContainer) {
    console.log('No slideshow container found');
    return;
  }

  console.log('Initializing Swiper slideshow');

  const swiper = new Swiper('.article-slideshow', {
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    effect: 'fade',
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 600,
    grabCursor: true,
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: '.article-slideshow-next',
      prevEl: '.article-slideshow-prev',
    },
    on: {
      init: function () {
        console.log('Swiper initialized successfully');
        updateSlideCounter(this);
      },
      slideChange: function () {
        console.log('Slide changed to:', this.activeIndex);
        updateSlideCounter(this);
      }
    }
  });

  function updateSlideCounter(swiper) {
    const currentElement = document.querySelector('.article-slideshow-navigation .slider-counter--current');
    const totalElement = document.querySelector('.article-slideshow-navigation .slider-counter--total');

    if (currentElement) {
      currentElement.textContent = swiper.realIndex + 1;
    }

    if (totalElement) {
      totalElement.textContent = swiper.slides.length;
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeSlideshow);
} else {
  initializeSlideshow();
}